import React, { useState, useRef, useEffect } from 'react'
import {
  ScrollView,
  View,
  KeyboardAvoidingView
} from 'react-native'
import PropTypes from 'prop-types'

import { VFScreen } from '@vfgroup-oneplatform/foundation/Components'
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import Id from '../../Components/IdStep'
import Offer from '../../Components/OfferStep'
import Summary from '../../Components/SummaryStep'
import ModalContent from '../../Components/ModalContent'
import Sim from '../../Components/SimStep'
import HorizontalStepper from '../../Components/HorizontalStepper'
import Loading from '../../Components/Loading'
import Start from '../../Components/Start'
import VerifyCodeModal from '../../Components/VerifyCodeModal'

import styles from './DigitalAcquisition.Styles'


const formatCount = (sec) => {
  if (sec.toString().length === 1) {
    return '0:0' + sec
  }
  return '0:' + sec
}

function DigitalAcquisition({
  screenTitle,
  onClose,
  steps,
  MNP,
  isLoading,
  onStartPress,
  //offers
  offers,
  selectedOffer,
  setSelectedOffer,
  offerError,
  offersLoading,
  // id step
  personalInfo,
  setPersonalInfo,
  addressInfo,
  setAddressInfo,
  showExtendedCards,
  validatePersonalNumber,
  citiesList,
  countriesList,
  gendersList,
  documentTypeList,
  validatePhoneNumber,
  channelList,
  postForm,
  verifyCostumer,
  //sim
  accountNumber,
  availableSims,
  selectedSimNumber,
  setSelectedSimNumber,
  resourcesError,
  resourcesLoading,
  getAvaliableResources,
  setIsCostumer,
  //summary
  onOrderConfirm,
  errorMessage,
  error,
  checkOrders,
  confirmLoading,
  //mnp verify code
  msisdn,
  sendVerifyCode,
  onCodeConfirm,

  API_KEY,
  theme,
  vfScreenProps,
}) {

  const activeSteps = []

  const [currentIndex, setCurrentIndex] = useState(0)
  const [showFirstStep, setShowFirstStep] = useState(MNP ? false : true)
  const [showVerifyModal, setShowVerifyModal] = useState(false)
  const [orderVisible, setOrderVisible] = useState(false)

  const [resendCodeLoading, setResendCodeLoading] = useState(false)
  const [count, setCount] = useState(30)
  const [formattedCount, setFormattedCount] = useState(formatCount(count))

  const scrollRef = useRef()

  const changeCurrentIndex = (ind) => {
    if (currentIndex === (activeSteps.length - 1)) {
      onOrderConfirm()
      setOrderVisible(true)
    } else {
      if (ind === 1 && MNP && !showVerifyModal) {
        sendVerifyCode()
        setShowVerifyModal(true)
      } else {
        setCurrentIndex(ind)
      }
    }
    // scrollRef.current?.scrollTo({
    //   y: 0,
    //   animated: true,
    // })
  }

  if (steps.length !== 0) {
    steps.map(step => {
      if (step.id === 'offer') {
        activeSteps.push(Offer)
      } else if (step.id === 'id') {
        activeSteps.push(Id)
      } else if (step.id === 'summary') {
        activeSteps.push(Summary)
      } else if (step.id === 'sim') {
        activeSteps.push(Sim)
      }
    })
  }

  const Step = activeSteps?.[currentIndex]

  const resendCode = () => {
    setResendCodeLoading(true)
    sendVerifyCode()
  }

  const codeConfirm = () => {
    onCodeConfirm()
    setShowVerifyModal(false)
    changeCurrentIndex(currentIndex + 1)
  }


  useEffect(() => {
    if (resendCodeLoading) {
      const interval = setInterval(() => {
        setCount(count - 1)
        setFormattedCount(formatCount(count - 1))
      }, 1000)

      if (count === 0) {
        setResendCodeLoading(false)
      }
      return () => {
        clearInterval(interval)
      }
    }
  }, [count, resendCodeLoading])



  const onStartJourney = () => {
    onStartPress && onStartPress()
    setShowFirstStep(false)
  }

  if (isLoading) {
    return (
      <Loading theme={theme} />
    )
  }


  if (orderVisible && !confirmLoading) {
    return (
      <View style={{ backgroundColor: theme.colors.cardBackgroundColor, flex: 1, paddingVertical: 16 }}>
        <ModalContent
          onClose={() => {
            setOrderVisible(false)
            onClose()
          }}
          error={error}
          errorMessage={errorMessage}
          onButtonPress={() => {
            onClose()
            setOrderVisible(false)
            if (!error) {
              checkOrders()
            }
          }}
          onCancelPress={() => {
            setOrderVisible(false)
            onClose()
          }}
        />
      </View>
    )
  }

  return (
    <>
      {showFirstStep ? <Start
        onStartJourney={onStartJourney}
        theme={theme}
        onClose={onClose}
      /> : <VFScreen
        title={screenTitle}
        onClose={onClose}
        {...vfScreenProps}
      >
        <HorizontalStepper
          steps={steps}
          activeStepIndex={currentIndex}
          style={styles.stepperContainer}
          isEditMode
          onStepPress={setCurrentIndex}
        />
        <ScrollView
          showsVerticalScrollIndicator={false}
          contentContainerStyle={styles.scrollviewContainer}
          ref={scrollRef}
          keyboardShouldPersistTaps='always'
          nestedScrollEnabled={true}
          style={{ flexGrow: 1 }}
        >
          <Step
            MNP={MNP}
            offersLoading={offersLoading}
            currentIndex={currentIndex}
            changeCurrentIndex={changeCurrentIndex}
            offers={offers}
            selectedOffer={selectedOffer}
            setSelectedOffer={setSelectedOffer}
            offerError={offerError}
            personalInfo={personalInfo}
            setPersonalInfo={setPersonalInfo}
            addressInfo={addressInfo}
            setAddressInfo={setAddressInfo}
            showExtendedCards={showExtendedCards}
            validatePersonalNumber={validatePersonalNumber}
            citiesList={citiesList}
            countriesList={countriesList}
            gendersList={gendersList}
            documentTypeList={documentTypeList}
            validatePhoneNumber={validatePhoneNumber}
            channelList={channelList}
            postForm={postForm}
            setIsCostumer={setIsCostumer}
            verifyCostumer={verifyCostumer}
            accountNumber={accountNumber}
            availableSims={availableSims}
            selectedSimNumber={selectedSimNumber}
            setSelectedSimNumber={setSelectedSimNumber}
            resourcesError={resourcesError}
            resourcesLoading={resourcesLoading}
            getAvaliableResources={getAvaliableResources}
            confirmLoading={confirmLoading}
            onClose={onClose}
            API_KEY={API_KEY}
            scrollRef={scrollRef}
          />
        </ScrollView>
        <VerifyCodeModal
          msisdn={msisdn}
          isVisible={showVerifyModal}
          toggleModal={() => setShowVerifyModal(false)}
          resendCodeLoading={resendCodeLoading}
          resendCode={resendCode}
          codeConfirm={codeConfirm}
          formattedCount={formattedCount}
        />
      </VFScreen>}
    </>
  )
}

DigitalAcquisition.defaultProps = {
  steps: [],
  offers: [],
  selectedOffer: 0,
  offerError: '',
  error: false,
  theme: {
    name: 'light',
    colors: LightThemeColors,
  },
}

DigitalAcquisition.propTypes = {
  screenTitle: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  steps: PropTypes.array.isRequired,
  MNP: PropTypes.bool,
  onStartPress: PropTypes.func,
  //for offers step
  offers: PropTypes.array,
  selectedOffer: PropTypes.number,
  setSelectedOffer: PropTypes.func,
  offerError: PropTypes.string,
  tryAgain: PropTypes.func,
  offersLoading: PropTypes.bool,
  //for id step
  personalInfo: PropTypes.object,
  setPersonalInfo: PropTypes.func,
  addressInfo: PropTypes.object,
  setAddressInfo: PropTypes.func,
  showExtendedCards: PropTypes.bool,
  validatePersonalNumber: PropTypes.func,
  citiesList: PropTypes.array,
  countriesList: PropTypes.array,
  gendersList: PropTypes.array,
  documentTypeList: PropTypes.array,
  validatePhoneNumber: PropTypes.func,
  channelList: PropTypes.array,
  postForm: PropTypes.func,
  verifyCostumer: PropTypes.func,
  setIsCostumer: PropTypes.func,
  //sim step
  accountNumber: PropTypes.string,
  availableSims: PropTypes.array,
  selectedSimNumber: PropTypes.string,
  setSelectedSimNumber: PropTypes.func,
  resourcesError: PropTypes.string,
  resourcesLoading: PropTypes.bool,
  getAvaliableResources: PropTypes.func,
  //summary
  onOrderConfirm: PropTypes.func,
  errorMessage: PropTypes.string,
  error: PropTypes.bool,
  checkOrders: PropTypes.func,
  confirmLoading: PropTypes.bool,
  //mnp
  msisdn: PropTypes.string,
  sendVerifyCode: PropTypes.func,
  onCodeConfirm: PropTypes.func,

  API_KEY: PropTypes.string,
  theme: PropTypes.object,
  vfScreenProps: PropTypes.object,
}

export default withTheme(DigitalAcquisition)
